import { globalErrorResponse, showNotification } from '../../store/notifications/actions';
import { deserializeFilter } from '../../shared/utils/deserializeFilter';
import { useDispatch } from 'react-redux';
import {
    isExcludeProductSelection,
    isIncludeProductSelection,
    ProductSelection
} from '../../shared/product-selection/ProductSelectionTypes';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { addProductsToGroupFromCartByFilter } from './addProductsToGroupFromCartByFilter';
import { addProductsToGroupFromCartByIds } from './addProductsToGroupFromCartByIds';

type GetRequestParams = {
    productSelection: ProductSelection;
    filterRequest: string;
    productGroupId: number;
};

const buildAddProductsCallback = (
    { productSelection, filterRequest, productGroupId }: GetRequestParams,
    t: TFunction
): (() => Promise<void>) => {
    return () => {
        if (isIncludeProductSelection(productSelection)) {
            const body = {
                productIds: productSelection.included.map(value => value.productId),
                amount: 1
            };
            return addProductsToGroupFromCartByIds(productGroupId, body);
        } else if (isExcludeProductSelection(productSelection)) {
            const body = {
                filterRequest: deserializeFilter(filterRequest, {
                    includeKey: 'include',
                    excludeKey: 'exclude'
                }),
                excludedProductIds: productSelection.excluded.map(({ productId }) => productId),
                amount: 1
            };

            return addProductsToGroupFromCartByFilter(productGroupId, body);
        } else {
            throw new Error(t('notifications.buildAddProductsCallback.error'));
        }
    };
};

export function useAddProductsToGroupFromCart(filter: string, productSelection: ProductSelection) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);

    return {
        isLoading,
        addToGroup: (productGroupId: number) => {
            const apiCallback = buildAddProductsCallback(
                {
                    productSelection,
                    filterRequest: filter,
                    productGroupId
                },
                t
            );

            setLoading(true);
            apiCallback()
                .then(() => {
                    dispatch(showNotification(t('notifications.addProductsToGroup.success')));
                })
                .catch(error => dispatch(globalErrorResponse(error)))
                .finally(() => {
                    setLoading(false);
                });
        }
    };
}
